import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Navigate, Link } from 'react-router-dom'
import { Button, Card, Container, Form, Alert } from 'react-bootstrap'
import useAuthStore from '../../stores/AuthStore'
import axios from '../../../../libs/axios'

const DEV_USERS = [
    { role: 'System',   email: 'system@local',  password: 'password' },
    { role: 'Admin',    email: 'admin@local',   password: 'password' },
    { role: 'Manager',  email: 'manager@local', password: 'password' },
    { role: 'Boss',     email: 'boss@local',    password: 'password' },
    { role: 'User',     email: 'user@local',    password: 'password' },
]

const SignInForm = () => {
    const store = useAuthStore()
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [errors, setErrors] = useState({})
    const [message, setMessage] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    function handleSubmit(event) {
        event.preventDefault()
        setMessage('')
        setErrors({})
        setIsLoading(true)

        const formData = new FormData(event.target)

        axios({
            url: `${process.env.REACT_APP_BACKEND_URL}/login`,
            method: 'post',
            data: formData,
        })
            .then(response => {
                localStorage.setItem('token', response.data.token)
                useAuthStore.setState({ user: response.data.user })
                useAuthStore.setState({ isAuthenticated: true })
                setIsLoading(false)
            })
            .catch(error => {
                setIsLoading(false)
                if (error.response?.status === 422) {
                    setErrors(error.response.data.errors || {})
                } else if (error.response?.status === 401) {
                    setMessage('Alamat emel atau katalaluan salah')
                } else {
                    setMessage(error.message || 'Ralat melayan server')
                }
            })
    }

    if (store.isAuthenticated === true) {
        return <Navigate to='/' replace />
    }

    return (
        <Container className='py-5 px-2 px-md-0' style={{ maxWidth: '450px', width: '100%' }}>
            <Card className='border-0 shadow-lg'>
                <Card.Body className='p-3 p-sm-4 p-md-5'>
                    <div className='text-center mb-4'>
                        <h3 className='fw-bold mb-2 fs-4'>Log Masuk</h3>
                        <p className='text-muted mb-0'>Guna Alamat Emel</p>
                    </div>

                    {message && (
                        <Alert variant='danger' className='mb-4'>
                            <FontAwesomeIcon icon='fa-solid fa-exclamation-circle' className='me-2' />
                            {message}
                        </Alert>
                    )}

                    <Form onSubmit={handleSubmit}>
                        <Form.Group className='mb-3'>
                            <Form.Label className='fw-semibold'>
                                <FontAwesomeIcon icon='fa-solid fa-envelope' className='me-2' />
                                Alamat Emel
                            </Form.Label>
                            <Form.Control
                                size='lg'
                                type='email'
                                name='email'
                                placeholder='nama@example.com'
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                isInvalid={!!errors.email}
                                disabled={isLoading}
                            />
                            <Form.Control.Feedback type='invalid'>
                                {errors.email}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className='mb-4'>
                            <Form.Label className='fw-semibold'>
                                <FontAwesomeIcon icon='fa-solid fa-lock' className='me-2' />
                                Katalaluan
                            </Form.Label>
                            <Form.Control
                                size='lg'
                                type='password'
                                name='password'
                                placeholder='Masukkan katalaluan anda'
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                isInvalid={!!errors.password}
                                disabled={isLoading}
                            />
                            <Form.Control.Feedback type='invalid'>
                                {errors.password}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Button
                            type='submit'
                            size='lg'
                            className='w-100 fw-semibold mb-4'
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <>
                                    <FontAwesomeIcon icon='fa-solid fa-sync' spin className='me-2' />
                                    Sedang memproses...
                                </>
                            ) : (
                                <>
                                    <FontAwesomeIcon icon='fa-solid fa-arrow-right-to-bracket' className='me-2' />
                                    Log Masuk
                                </>
                            )}
                        </Button>

                        <div className='d-flex gap-2 flex-wrap justify-content-center text-center fs-6'>
                            {process.env.REACT_APP_SHOW_CREDENTIALS === 'true' && (
                                <Link to='/sign-in-by-nric'>
                                    <FontAwesomeIcon icon='fa-solid fa-id-card' className='me-1' />
                                    Kad Pengenalan
                                </Link>
                            )}
                            <Link to='/password/email'>
                                <FontAwesomeIcon icon='fa-solid fa-question' className='me-1' />
                                Lupa Katalaluan
                            </Link>
                            <Link to='/sign-up'>
                                <FontAwesomeIcon icon='fa-solid fa-user-plus' className='me-1' />
                                Daftar
                            </Link>
                        </div>
                    </Form>
                </Card.Body>
            </Card>

            {process.env.REACT_APP_SHOW_CREDENTIALS === 'true' && (
                <Card className='mt-4 border-light bg-light'>
                    <Card.Body className='p-3'>
                        <div className='text-muted fw-semibold d-block mb-2 fs-6'>
                            <FontAwesomeIcon icon='fa-solid fa-flask' className='me-1' />
                            DEV — Akaun Ujian
                        </div>
                        <div className='d-flex flex-wrap gap-2'>
                            {DEV_USERS.map(u => (
                                <Button
                                    key={u.role}
                                    variant='outline-secondary'
                                    size='sm'
                                    onClick={() => { setEmail(u.email); setPassword(u.password) }}
                                    disabled={isLoading}
                                >
                                    {u.role}
                                </Button>
                            ))}
                        </div>
                    </Card.Body>
                </Card>
            )}
        </Container>
    )
}

export default SignInForm
